import useEventDetailsElement from '../../../hooks/adminEvents/useEventDetailsElement';

const EventDetails = () => useEventDetailsElement();

export default EventDetails;
